import { type ComponentProps, type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { listItemDescription, listItemLabel, listItemStack } from './list-styles'

interface ListItemTextProps extends ComponentProps<'span'> {
  /** A second line under the title. It wraps; the title still truncates. */
  description?: ReactNode
}

/**
 * The text of a list row, shared by Menu, ContextMenu, Select and Combobox. Without a description
 * it is the filling, truncating label; with one it stacks the description under the title and the
 * row grows to fit (see `listItemVariants`).
 */
function ListItemText({ description, className, children, ...props }: ListItemTextProps) {
  if (!description) {
    return (
      <span className={twMerge(listItemLabel, className)} {...props}>
        {children}
      </span>
    )
  }
  return (
    <span className={twMerge(listItemStack, className)} {...props}>
      <span className="truncate">{children}</span>
      <span data-slot="list-item-description" className={listItemDescription}>
        {description}
      </span>
    </span>
  )
}

export { ListItemText }
export type { ListItemTextProps }
